import React, { FC } from 'react';
import { Box, Button, Text } from '@chakra-ui/react';
import { TokensSelector } from '@app/screens/liquidity/LiquidityWizard/components/SelectTokensStep/components/TokensSelector';
import { PoolsList } from '@app/screens/liquidity/LiquidityWizard/components/SelectTokensStep/components/PoolsList';
import { SubmitButton } from '@app/components/SubmitButton';
import { useLiquidityWizardState } from '@app/screens/liquidity/LiquidityWizard/state';
import { LiquidityWizardMinInfo } from '@app/screens/liquidity/LiquidityWizard/hooks/useDerivedMintInfo';

interface Props {
  mintInfo: LiquidityWizardMinInfo;
}

export const SelectTokensStep: FC<Props> = ({ mintInfo }) => {
  const {
    currencyA,
    currencyB,
    actions: { setStep }
  } = useLiquidityWizardState();

  return (
    <Box maxWidth={768} mx="auto" mt={8}>
      <Text as="h4" fontSize={18} fontWeight={600}>
        Select Tokens
      </Text>
      <Text fontSize={14} my={4} lineHeight={1.4} color="neutral.300">
        To begin, you will need to choose two tokens (of your choice) to
        contribute to a pool. As you select two tokens, you will see existing
        pools with that same combination of tokens for you to choose from.
      </Text>
      <TokensSelector />
      {currencyA && currencyB && mintInfo.flags.hasStrategies && <PoolsList />}
      <SubmitButton
        label="Next"
        onClick={() => {
          setStep(1);
        }}
        disabled={!currencyA || !currencyB}
      />
    </Box>
  );
};
